import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../component/Header";
import IconKey from "../../component/SvgIcons/IconKey";
import { useSwal } from "../../component/sweetalert";
import api from "../../Services/api";
export default function EdituserDetails() {
  const { id } = useParams();
   const alert = useSwal();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedMode, setSelectedMode] = useState('');
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    email: "",
    contact: "",
    address: "",
    type: "",
    status: "",   
  });

  const handleRadioChange = (userstatus) => {
    setSelectedMode(userstatus.target.value);
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await api.post(`/getuser/${id}`);
        // Assuming your endpoint returns the user object in response.data
        if (response.data.status !== undefined) {
          setSelectedMode(response.data.status === true || response.data.status === 1 ? "Active" : "Deactive");
        }

        setFormData(response.data);
      } catch (err) {
        console.error("Error fetching user data:", err);
        setError("Error loading user details.");
      }
    };

    fetchUser();
  }, [id]);

const handleInputChange = (e) => {
  const { id, name, value } = e.target;
  const key = id || name; // ✅ use whichever is available
  setFormData((prev) => ({ ...prev, [key]: value }));
}
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedMode) {
      alert("error", "Please select a user status (Active or Deactive)", "Validation Error");
        return;
      }

    try {
      setLoading(true);
      const payload = {
        ...formData,
        status: selectedMode === 'Active' ? 1 : 0,
      };
      // Send updated data to the API.
      await api.post(`/updateUser/${id}`, payload);      
      alert("success", "User details have been updated.", "Saved!");
      navigate("/users-list"); 
      setLoading(true)
    } catch (err) {
      console.error("Error updating user:", err);
      setError("An error occurred while updating the user.");
      alert("error", "An error occurred while updating the user.", "Oops...");      
    }finally {
      setLoading(false);
    }
  };

  const handleContactChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    const contactRegex = /^[6-9][0-9]{9}$/; // 10 digits starting with 6-9

    if (value.length > 13) {
      return; // Prevent more than 10 digits
    }
    setFormData((prev) => ({
      ...prev,
      contact: value,
    }));
    setError(
      !contactRegex.test(value)
        ? "Contact number must be 10 digits and start with 6-9."
        : ""
    );
  };

  return (
    <section className="dashboardpage">
      <Header pageTitle="Edit User Details" backTo={"/users-list"} />
      <div className="pageLeftspace">
      <div className="d-flex justify-content-start col-xl-6 col-12">
        <form className="form-fields d-flex " onSubmit={handleSubmit}>
          <div className="grid-container">

             <div className="input-container">
              <select
                id="type" 
                name="type"
                className="form-select"
                style={{ width: "100%" }}
                value={formData.type}
                onChange={handleInputChange}
                required
              >
                <option value="" disabled>Select User Type</option>
                <option value="Admin">Admin</option>
                <option value="User">User</option>
              </select>
              </div>

            <div className="input-container">
              <input
                type="text"
                id="username"
                placeholder="Enter User Name"
                value={formData.username}
                onChange={handleInputChange}
                required
              />
              {/* <label htmlFor="username">User Name</label> */}
              <span className="underline"></span>
            </div>

            <div className="input-container">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="Enter Password"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
              {/* <label htmlFor="password">password</label> */}
              <span className="underline"></span>
              <span
                className="icon-key"
                onClick={() => setShowPassword(!showPassword)}
              >
                <IconKey />
              </span>
            </div>

            <div className="input-container">
              <input
                type="email"
                id="email"
                placeholder="Enter Email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              {/* <label htmlFor="email">Email</label> */}
              <span className="underline"></span>
            </div>

            <div className="input-container">
              {error && (
                <ins
                  className="error-text"
                  style={{ color:"var(--RedColor)" }}
                >
                  {error}
                </ins>
              )}
              <input
                type="text"
                id="contact"
                placeholder="Enter Contact"
                value={formData.contact}
                onChange={handleContactChange}
                maxLength="10"
                required
              />
              {/* <label htmlFor="contact">contact</label> */}
              <span className="underline"></span>
            </div>

            <div className="input-container">
              <input
                type="text"
                id="address"
                placeholder="Enter Address"
                value={formData.address}
                onChange={handleInputChange}
                required
              />
              {/* <label htmlFor="Title">Address</label> */}
              <span className="underline"></span>
            </div>

            <div className="radio-container">
              <span className="radio-label">Select User Status</span>
              <div className="radio-container button">
                <label className={`radio-option ${selectedMode === 'Active' ? 'active' : ''}`}>
                  <input
                    type="radio"
                    name="confirm"
                    value="Active"
                    onChange={handleRadioChange}
                    checked={selectedMode === "Active"}
                    required
                  />
                  Active
                </label>
                <label className={`radio-option ${selectedMode === 'Deactive' ? 'active' : ''}`}>
                  <input
                    type="radio"
                    name="confirm"
                    value="Deactive"
                    onChange={handleRadioChange}
                    checked={selectedMode === "Deactive"}
                    required
                  />
                  Deactive
                </label>
              </div>
            </div>

              
            <button
              className="btn btn-purpal"
              type="submit"
              disabled={loading}
            >
              {loading ? "Update..." : "Update"}
            </button>
          </div>
        </form>
        </div>
      </div>
    </section>
  );
}
